import { render, staticRenderFns } from "./VersioningModal.vue?vue&type=template&id=052d3630&lang=pug&"
import script from "./VersioningModal.vue?vue&type=script&lang=js&"
export * from "./VersioningModal.vue?vue&type=script&lang=js&"
import style0 from "./VersioningModal.vue?vue&type=style&index=0&id=052d3630&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports